import React, { Component } from "react";
import { Container, Row, Col, Button, Label, FormGroup, Input } from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../../principal/containers/DataWrapper";
import Footer from "../../../comum/components/Footer";
import ModalAviso from "../../../comum/components/ModalAviso";
import ModalForm from '../../../comum/components/ModalForm'
import FormInput from '../../../comum/components/FormInput';
import _ from 'lodash';
import { IconeDelete, IconeEditar, IconeBuscar, IconeSetaSubir, IconeSetaDescer, IconeGenerico } from '../../../comum/components/Icones';
import Select from 'react-select';
import AgServicosCadastrarStore from "../stores/AgServicosCadastrarStore";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import Card from "../../../comum/components/Card";
import FormOnlyPositiveNumberSimples from "../../../comum/components/FormNumberSimples";
import CheckboxField from "../../../comum/components/CheckboxField";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import { isInvalidoPlacas } from "../../../../utils/validadores";
import {IconeCarregar, IconeInformacao} from "../../../comum/components/Icones";
import ModalMultiplaEscolha from "../../../comum/components/ModalMultiplaEscolha";
import {AreaInserirAnexos} from "../../../comum/components/AreaInserirAnexos";
import CheckboxArea from "../../../comum/components/CheckboxArea";
import { AreaSelecaoContainers } from "../components/AreaSelecaoContainers";
import { AreaSelecaoContainersMultiplos } from "../components/AreaSelecaoContainersMultiplos";
import { AreaSelecaoNCMs } from "../components/AreaSelecaoNCMs";
import {AreaSelecaoNCMsMultiplos} from "../components/AreaSelecaoNCMsMultiplos";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { sanitizarCnpj } from "../../../../utils/sanitizar";

@inject("store")
@DataWrapper
@observer
export class AgServicosCadastrar extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.service = this.props.service;
        this.controllerServicos = this.props.controller;
        this.controller = new AgServicosCadastrarStore(this.service);
        this.appStore.showVoltarTopBar(true, null, null, () => { this.appStore.showVoltarTopBar(false, '/'); this.controllerServicos.sairCadastrar() });
    };

    componentDidMount() {
        if (!this.props.idEditando) {
            this.cadastrar();
        } else {
            this.editar(this.props.idEditando);
        }
    };

    temInicioPrevisto = () => {
        if (["MANUSEIO DE IMPORTACAO","MANUSEIO DE EXPORTACAO"].includes(this.controller.grupoSelecionado.label))
            return this.controller.dadosDoServico && this.controller.dadosDoServico.AgendServ.DatFimPrev
        else 
         return false
    };

    cadastrar = () => {
        this.controller.isEditar = false;
    };

    editar = (id) => {
        if (this.props.AgendGrupoServIdMultiplos === 2) {
            this.controller.isEditar = true;
            this.controller.iniciaEdicaoMultiplos(id, this.props.AgendGrupoServIdMultiplos, this.props.AgendTipoServIdMultiplos, this.props.PlacaMultiplos,  this.props.HoraAgendMultiplos, this.props.DatAgendMultiplos);
        } else {
            this.controller.isEditar = true;
            this.controller.iniciaEdicao(id);
        }
    };

    aviso = () => {
        if (this.controller.listaMensagens != false){
            return <ModalAviso onClickFechar={ () => this.controller.listaMensagens = false }>
                { this.controller.listaMensagens.map((msg, x) =>
                    <h2 key={x}>{ msg }</h2>
                )}
            </ModalAviso>
        }
    };

    
    avisoEdicaoIniciadaMultiplos = () => {
        if (this.controller.edicaoMultipla){
            return  <div>
            <ModalContainer zIndex={100}>
                <ModalDialog className="nosso-modal">
                    <div className={`modal-aviso`}>
                        <h2 >Carregando dados da edição, aguarde por favor!</h2>
                         <div className={"item-modal-change"}>
                            <IconeCarregar tamanho="2x" />
                        </div>
                    </div>
                </ModalDialog>
            </ModalContainer>
        </div>
            
        }
    };

    modalFimAgendamento = () => {
        if (this.controller.modalFimAgendamento) {
            console.log('modalFim', this.controller.modalFimAgendamento)
            if (this.controller.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                return <ModalMultiplaEscolha titulo={ this.controller.resultadoFimAgendamento.Sucesso ? "Concluído" : "" }
                mensagem={ this.controller.resultadoFimAgendamento.Mensagem }>
                    {
                    <div className="justify-content-end">
                    <Label className="btn-primary" onClick={ () => this.controller.reiniciarCadastroMultiplos() }>Novo Agendamento</Label>
                    {/* <Label className="btn-primary" onClick={ () => this.editar(this.controller.resultadoFimAgendamento.AgendServId) }>Continuar editando</Label> */}
                    <Label className="btn-primary" onClick={ () => this.controllerServicos.sairCadastrar() }>Consultar Agendamentos</Label>
                    </div>
                    }
                    </ModalMultiplaEscolha>
            } else {
                return <ModalMultiplaEscolha titulo={ this.controller.resultadoFimAgendamento.Sucesso ? "Concluído" : "" }
                mensagem={ this.controller.resultadoFimAgendamento.Mensagem }>
                    {
                    <div className="justify-content-end">
                    <Label className="btn-primary" onClick={ () => this.controller.reiniciarCadastro() }>Novo Agendamento</Label>
                    <Label className="btn-primary" onClick={ () => this.editar(this.controller.resultadoFimAgendamento.AgendServId) }>Continuar editando</Label>
                    <Label className="btn-primary" onClick={ () => this.controllerServicos.sairCadastrar() }>Consultar Agendamentos</Label>
                    </div>
                    }
                    </ModalMultiplaEscolha> 
            }
        }
    };
 
    // Area de campos
    campoSelectBl = (md, lg, xl) => {
       
            return <React.Fragment>
                {this.controller.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA" ? <FormSelectSimples titulo="Tipo" xs={12} sm={12} md={md} lg={lg} xl={xl}
                        itens={ this.controller.tipos }
                        dado={ this.controller.tipoSelecionado }
                        bloqueado={ !this.temInicioPrevisto() ? (!this.controller.tipos || this.controller.isEditar) : true}
                        onChange={ (event) => this.controller.onChangeTipo(event) } />  : ""}
                    {this.controller.atualiza && this.controller.parametrosDeCampos.selectBL &&
                    
                    <FormInputSimples titulo="BL" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                      dado={ this.controller.blNumero }
                                      bloqueado={ !this.temInicioPrevisto() ? !this.controller.bls : true}
                                      obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.selectBL}
                                      alerta={this.controller.alertaNumeroBl()}
                                      onChange={(event) => this.controller.setBLNumero(event)} 
                                      onBlur={(event) => this.controller.changeBlNumero(event)} 
                                      onEnter={() => this.controller.changeBlNumero(this.controller.blNumero)}
                    />}
                </React.Fragment>
    };

    campoInputMostraCliente = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputMostraCliente)
            return (<React.Fragment>
                <FormInputSimples titulo="CNPJ" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                    dado={ this.controller.dadosDoServico.AgendServ.CnpjCobrar }
                                    bloqueado={true}
                                    onChange={() => { }} />
                <FormInputSimples titulo="Razão social" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                         dado={ this.controller.dadosDoServico.AgendServ.RazaoSocialCobrar }
                                         bloqueado={true}
                                         onChange={() => { }} />                
            </React.Fragment>)
    };

    campoInputMostraRazao = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputMostraRazSocial)
            return <FormInputSimples titulo="Razão social" xs={12} sm={12} md={md} lg={lg} xl={xl}
                dado={this.controller.dadosDoServico.AgendServ.RazaoSocialDespa}
                bloqueado={true}
                onChange={() => { }} />
    };

    campoInputMostraRazaoCobrarDe = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputMostraRazSocialCobrarDe)
            return <FormInputSimples titulo="Razão social" xs={12} sm={12} md={md} lg={lg} xl={xl}
                dado={this.controller.dadosDoServico.AgendServ.RazaoSocialCobrar}
                bloqueado={true}
                onChange={() => { }} />
    };

    campoInputContainer = (md, lg, xl, pos) => {
        if (this.controller.parametrosDeCampos.inputContainer && this.controller.dadosDoServico.AgendServItens[pos])
            return <FormInputSimples titulo="Container" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                     dado={ this.controller.dadosDoServico.AgendServItens[pos].CodCntr }
                                     bloqueado={this.temInicioPrevisto()}
                                     obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.inputContainer }
                                     alerta={ this.controller.alertaContainer() }
                                     onChange={ (event) => this.controller.dadosDoServico.AgendServItens[pos].CodCntr = event.target.value.toUpperCase() } />
    };

    campoInputDiasFreetime = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputDiasFreetime)
            return this.controller.atualiza && 
                   <FormOnlyPositiveNumberSimples titulo="Dias freetime" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                  dado={ this.controller.dadosDoServico.AgendServ.DiasFreetime }
                                                  bloqueado={this.temInicioPrevisto()}
                                                  iconeInfo={true}
                                                  limiteMaximo={3}
                                                  informacoes={"Favor inserir freetime (demurrage) negociado entre armador e importador"}
                                                  onChange={ (event) => {this.controller.dadosDoServico.AgendServ.DiasFreetime = event.target.value.toUpperCase()} } />
    };

    checkboxEhClienteEstrangeiro = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.checkEhClienteEstrangeiro)
            return <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                  titulo={"É cliente estrangeiro?"} text={"Sim"}
                                  bloqueado={this.temInicioPrevisto()}
                                  ativo={ this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro }
                                  onClick={ () => this.controller.changeEhClienteEstrangeiro() } />
    };

    campoInputCliente = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputCliente)
            return <FormInput titulo="Cliente " xs={12} sm={12} md={md} lg={lg} xl={xl}
                dado={this.controller.dadosDoServico.AgendServ.CnpjDespa}
                sanitizar={sanitizarCnpj}
                limiteMaximo={14}
                onChange={(event) => this.controller.dadosDoServico.AgendServ.CnpjDespa = event.target.value ? event.target.value : null}
                obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.inputCliente}
                bloqueado={this.temInicioPrevisto()}
                alerta={this.controller.alertaCliente()}
                onBlur={() => this.controller.buscarParceiroPorCnpj()}
            />
    };

    campoSelectClienteEstrangeiro = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.selectClienteEstrangeiro)
            return <FormSelectSimples titulo="Cliente" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                      itens={this.controller.clientesEstrangeiros}
                                      dado={this.controller.clienteEstrangeiroSelecionado}
                                      bloqueado={!this.temInicioPrevisto() ? !this.controller.clientesEstrangeiros: true}
                                      alerta={ this.controller.alertaCliente() }
                                      onChange={(event) => this.controller.changeClienteEstrangeiro(event)} />
    };

    checkboxEhCobrarDeEstrangeiro = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.checkEhCobrarDeEstrangeiro)
            return <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                  titulo={"É cobrar de estrangeiro?"} text={"Sim"}
                                  bloqueado={this.temInicioPrevisto()}
                                  ativo={ this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro }
                                  onClick={ () => this.controller.changeEhCobrarDeEstrangeiro() } />
    };

    campoInputCobrarDe = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.inputCobrarDe)
            return <FormOnlyPositiveNumberSimples titulo="Cobrar de " xs={12} sm={12} md={md} lg={lg} xl={xl}
                                     dado={ this.controller.dadosDoServico.AgendServ.CnpjCobrar }
                                     onChange={ (event) => {this.controller.dadosDoServico.AgendServ.CnpjCobrar = event.target.value ? event.target.value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '') : event.target.value } }
                                     obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.inputCobrarDe }
                                     bloqueado={this.temInicioPrevisto()}
                                     alerta={ this.controller.alertaCobrarDe() }
                                     onBlur={ () => this.controller.buscarParceiroPorCnpjCobrarDe() } />
    };

    campoSelectCobrarDeEstrangeiro = (md, lg, xl) => {
        if (this.controller.parametrosDeCampos.selectClienteEstrangeiro)
            return <FormSelectSimples titulo="Cobrar de" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                      itens={this.controller.clientesEstrangeiros}
                                      dado={ this.controller.cobrarDeEstrangeiroSelecionado }
                                      bloqueado={!this.temInicioPrevisto() ? !this.controller.clientesEstrangeiros : true}
                                      alerta={ this.controller.alertaCobrarDe() }
                                      onChange={(event) => this.controller.changeCobrarDeEstrangeiro(event)} />
    };

    campoTabelaContainers = (md=12, lg=12, xl=12) => {
        if (this.controller.parametrosDeCampos.tabelaSelecionarContainers)
            return <Col xs={12} sm={12} md={md} lg={lg} xl={xl}>
                <Label>Seleção dos containers</Label>
                <AreaSelecaoContainers controller={this.controller} bloqueado={this.temInicioPrevisto()} />
                { (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.tabelaSelecionarContainers && this.controller.dadosDoServico.AgendServItens.length===0)
                    && <Label className="label-danger">{ this.controller.msgObrigatorio }</Label> }
            </Col>
    };

    areaSelecaoNcm = (md, lg, xl, sm=12, xs=12) => {
        if (this.controller.parametrosDeCampos.selectNCM && this.controller.ncms)
            return <Col xs={12} sm={12} md={md} lg={lg} xl={xl}>
                        <Label>Seleção de NCM</Label>
                        <AreaSelecaoNCMs controller={this.controller} bloqueado={this.temInicioPrevisto()} />
                        { (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.selectNCM && this.controller.dadosDoServico.AgendServItens.length===0)
                            && <Label className="label-danger">{ this.controller.msgObrigatorio }</Label> } 
                        { this.controller.parametrosDeCampos.msgNCM &&
                            <div className="d-flex align-items-center">
                                <div><IconeInformacao className="pr-1" /></div>
                                <Label className="mt-1 informacoes">{ this.controller.parametrosDeCampos.msgNCM }</Label>
                            </div> }                       
                    </Col>
    };

    campoObservacao = (md, lg, xl) => {
        // iconeInfo={true}
        // extraInfo={"Informar os dados para ajuste do set point."}
        if (this.controller.parametrosDeCampos.inputObservacao)
            return <FormInputSimples titulo="Observações" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                    dado={ this.controller.dadosDoServico.AgendServ.DscObs }
                                    bloqueado={this.temInicioPrevisto()}
                                    type="textarea" limiteMaximo={2000}
                                    iconeInfo={this.controller.observacaoGrupo.length>0}
                                    extraInfo={this.controller.observacaoGrupo}
                                    onChange={ (event) => this.controller.dadosDoServico.AgendServ.DscObs = event.target.value.toUpperCase() }/>
    };

    campoInsereAnexos = (md, lg, xl, sm=12, xs=12) => {
        if (this.controller.parametrosDeCampos.campoInsereAnexos)
            return <Col xl={xl} lg={lg} md={md} sm={sm} xs={xs}>
                <Label>Anexos</Label>
                <AreaInserirAnexos anexos={ this.controller.listaAnexos } 
                                   guardaNovo={ this.controller.insereAnexo } 
                                   removerAnexo={ this.controller.removerAnexo } 
                                   visualizarAnexo={ this.controller.visualizarAnexo } 
                                   edicao={this.controller.isEditar} 
                                   descricao={"descricao"} 
                />
                { this.controller.parametrosDeCampos.msgAnexos
                    && <div className="d-flex align-items-center">
                        <div><IconeInformacao className="pr-1" /></div>
                        <Label className="informacoes">{ this.controller.parametrosDeCampos.msgAnexos }</Label>
                    </div> }
            </Col>;
    };
    // FIM Area de campos

    // Area de formularios
    opcoesGerais = () => {
        let md = 3; let lg = 3; let xl = 3;
        return <Row className="area-form opcoes-topo">
                <FormSelectSimples titulo="Grupo" xl={{size: xl, offset: 6 }} lg={{size: lg, offset: 6 }} md={md} sm={12} xs={12}
                    itens={ this.controller.grupos } naoLimpar={true}
                    dado={ this.controller.grupoSelecionado }
                    bloqueado={!this.temInicioPrevisto() ? (!this.controller.grupos || this.controller.isEditar) : true}
                    onChange={ (event) => this.controller.onChangeGrupo(event) } />
                {
                    this.controller.grupoSelecionado && this.controller.carregandoTipos
                    ? <Col xl={xl} lg={lg} md={md} sm={12} xs={12} className="d-flex align-items-center">
                        <IconeCarregar tamanho="2x"  />
                    </Col>
                    : <FormSelectSimples titulo="Tipo" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        itens={ this.controller.tipos }
                        dado={ this.controller.tipoSelecionado }
                        bloqueado={ !this.temInicioPrevisto() ? (!this.controller.tipos || this.controller.isEditar) : true}
                        onChange={ (event) => this.controller.onChangeTipo(event) } />   
                }
            </Row>;
    };

    dadosDoBl = () => {
        let md = 3; let lg = 3; let xl = 3;
        if(this.controller.grupoSelecionado.label!=="CARREGAMENTO DE CARGA SOLTA")
        {
            if (this.controller.parametrosDeCampos.dadosDoBl){
            return <Card className={"secao"} title={"Dados de BL"} >
                <Row>
                    { this.campoSelectBl(md, lg, xl) }
                    { this.campoInputMostraCliente(md, lg, xl) }
                    { this.campoInputDiasFreetime(md, lg, xl) }
                    { (this.controller.parametrosDeCampos.checkboxComboio)
                        && <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                          text={"Sim"}
                                          titulo={"Carregamento de comboio?"}
                                          bloqueado={this.temInicioPrevisto()}
                                          ativo={ this.controller.dadosDoServico.AgendServ.FlgComboio==='S' }
                                          onClick={ () => { 
                                            this.controller.dadosDoServico.AgendServ.FlgComboio = this.controller.dadosDoServico.AgendServ.FlgComboio==='S' ? 'N' : 'S';
                                            this.controller.dadosDoServico.AgendServ.FlgComboio==='S' ? this.controller.changeBlNumero(this.controller.blNumero) : 
                                            this.controller.changeBlNumero("");
                                          } } /> }
                </Row>
            </Card>
            }
        }else
        {
            return <Card className={"secao"} title={"Dados de BL"} >
                <Row>
                    { this.campoSelectBl(md, lg, xl) }
                    { this.campoInputMostraCliente(md, lg, xl) }
                    { this.campoInputDiasFreetime(md, lg, xl) }
                    { (this.controller.parametrosDeCampos.checkboxComboio)
                        && <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                          text={"Sim"}
                                          titulo={"Carregamento de comboio?"}
                                          bloqueado={this.temInicioPrevisto()}
                                          ativo={ this.controller.dadosDoServico.AgendServ.FlgComboio==='S' }
                                          onClick={ () => { 
                                            this.controller.dadosDoServico.AgendServ.FlgComboio = this.controller.dadosDoServico.AgendServ.FlgComboio==='S' ? 'N' : 'S';
                                            this.controller.dadosDoServico.AgendServ.FlgComboio==='S' ? this.controller.changeBlNumero(this.controller.blNumero) : 
                                            this.controller.changeBlNumero("");
                                          } } /> }
                </Row>
            </Card>
        }
       
    };

    dadosGerais = () => {
        let md = 3; let lg = 3; let xl = 3;
        let tamAnexos = (this.controller.parametrosDeCampos.selectNCM && this.controller.ncms) ? 3 : 6;
        if (this.controller.parametrosDeCampos.dadosGerais)
            return <Card className={"secao"} title={"Dados gerais"} >
                <Row>
                    { this.campoInputContainer(md, lg, xl, 0) }
                    { this.controller.parametrosDeCampos.selectContainer
                        && <FormSelectSimples titulo="Container" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                              itens={ this.controller.containersSetPoint }
                                              dado={ this.controller.containerSetPointSelecionado }
                                              bloqueado={!this.temInicioPrevisto() ? !this.controller.containersSetPoint : true}
                                              obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.selectContainer}
                                              alerta={ (this.controller.salvo && !this.controller.containerSetPointSelecionado) ? this.controller.msgObrigatorio : false }
                                              onChange={ (event) => this.controller.changeContainerSetPoint(event) } /> }
                </Row>
                { this.controller.parametrosDeCampos.inputCliente
                    && <Row>
                        { this.checkboxEhClienteEstrangeiro(md, lg, xl) }
                        { !this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                            && <React.Fragment>
                                {this.campoInputCliente(md, lg, xl)}
                                {this.campoInputMostraRazao(md, lg, xl)}
                            </React.Fragment>
                        }
                        { this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                            && this.campoSelectClienteEstrangeiro(md, lg, xl)
                        }
                    </Row>
                }
                { this.controller.parametrosDeCampos.inputCobrarDe
                    && <Row>
                        { this.checkboxEhCobrarDeEstrangeiro(md, lg, xl) }
                        { !this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                            && <React.Fragment>
                                { this.campoInputCobrarDe(md, lg, xl) }
                                { this.campoInputMostraRazaoCobrarDe(md, lg, xl) }
                            </React.Fragment>
                        }
                        { this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                            && this.campoSelectCobrarDeEstrangeiro(md, lg, xl)
                        }
                    </Row>
                }
                <Row>
                    { this.campoTabelaContainers(12, 6, 6) }
                    { this.areaSelecaoNcm(6, 3, 3, 6) }
                    { this.campoInsereAnexos(6, tamAnexos, tamAnexos, 6) }
                </Row>
                <Row>
                    { this.campoObservacao(6, 6, 6) }
                </Row>
            </Card>
    };

    dadosDaTransportadora = () => {
        let md = 6; let lg = 6; let xl = 6;
        if (this.controller.parametrosDeCampos.dadosDaTransportadora)
            return <Col xs={12} sm={12} md={6} lg={6} xl={6} >
                    <Card className={"secao"} title={"Dados do veículo"} >
                        <Card className={"card-branco"} >
                            <Row className={"secao"}>
                            { (this.controller.parametrosDeCampos.selectTransportadora)
                                && <FormSelectSimples titulo="Transportadora" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    itens={ this.controller.transportadoras }
                                                    dado={ this.controller.transportadoraSelecionada }
                                                    bloqueado={ !this.temInicioPrevisto() ? !this.controller.transportadoras : true}                                                    
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && !this.controller.transportadoraSelecionada) ? this.controller.msgObrigatorio : false }
                                                    onChange={ (event) => this.controller.changeTransportadora(event) } /> }
                            { (this.controller.parametrosDeCampos.selectTipoDeVeiculo)
                                && <FormSelectSimples titulo="Tipo de veículo" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    itens={ this.controller.tiposVeiculo }
                                                    dado={ this.controller.tipoVeiculoSelecionado }
                                                    bloqueado={ !this.temInicioPrevisto() ? !this.controller.tiposVeiculo : true }
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && !this.controller.tipoVeiculoSelecionado) ? this.controller.msgObrigatorio : false }
                                                    onChange={ (event) => this.controller.changeTipoVeiculo(event) } /> }
                            { (this.controller.parametrosDeCampos.inputPlaca)
                                && <FormInputSimples titulo="Placa" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCavalo }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCavalo && this.controller.dadosDoServico.AgendServ.PlacaCavalo.length===0 ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacas }
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCavalo = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacas = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCavalo) } } /> }
                            { (this.controller.parametrosDeCampos.inputCarreta1)
                                && <FormInputSimples titulo="Carreta 1" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCarret1 }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCarret1 && this.controller.dadosDoServico.AgendServ.PlacaCarret1.length===0 ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacaCarret1 }
                                                    obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora}
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCarret1 = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacaCarret1 = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCarret1) } } /> }
                            { (this.controller.parametrosDeCampos.inputCarreta2)
                                && <FormInputSimples titulo="Carreta 2" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCarret2 }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCarret2 && this.controller.dadosDoServico.AgendServ.PlacaCarret2.length===0 && this.controller.tipoVeiculoSelecionado.value==='B' ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacaCarret2 }
                                                    obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora
                                                                    && this.controller.tipoVeiculoSelecionado && this.controller.tipoVeiculoSelecionado.value==='B'}
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCarret2 = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacaCarret2 = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCarret2) } } /> }
                            </Row>
                        </Card>
                    </Card>
                </Col>
    };

    dadosDoMotorista = () => {
        let md = 6; let lg = 6; let xl = 6;
        if (this.controller.parametrosDeCampos.dadosDoMotorista)
            return <Col xs={12} sm={12} md={6} lg={6} xl={6} >
                    <Card className={"secao"} title={"Dados do motorista"} >
                        <Card className={"card-branco"} >
                            <Row className={"secao"} >
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputCNH)
                                && <FormOnlyPositiveNumberSimples titulo="CNH" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={15}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Cnh }
                                                                  bloqueado={ this.temInicioPrevisto()}
                                                                  obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                                  alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.Cnh===0 ) ? this.controller.msgObrigatorio : false }
                                                                  onChange={ (event) => {this.controller.dadosDoServico.AgendServMotorista.Cnh = parseInt(event.target.value); 
                                                                                         this.controller.dadosDoServico.AgendServ.Cnh = parseInt(event.target.value)}}
                                                                  onBlur={ () => this.controller.onBlurMotoristaCNH() } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.selectCategoria)
                                && <FormSelectSimples titulo="Categoria" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                                      itens={ this.controller.categorias }
                                                      dado={ this.controller.categoriaSelecionada }
                                                      bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaCategCnh)  : true}
                                                      alerta={ (this.controller.salvo && !this.controller.categoriaSelecionada) ? this.controller.msgObrigatorio : false }
                                                      onChange={ (event) => this.controller.changeCategoria(event) } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputNome)
                                && <FormInputSimples titulo="Nome" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                     dado={ this.controller.dadosDoServico.AgendServMotorista.Nome }
                                                     obrigatorio={ !this.controller.motoristaBloqueado && this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                     bloqueado={ !this.temInicioPrevisto() ? this.controller.motoristaBloqueado && this.controller.bloqueiaNomeMotorista : true}
                                                     alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.Nome && this.controller.dadosDoServico.AgendServMotorista.Nome.length===0 ) ? this.controller.msgObrigatorio : false }
                                                     onChange={ (event) => this.controller.dadosDoServico.AgendServMotorista.Nome = event.target.value.toUpperCase() } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputCPF)
                                && <FormOnlyPositiveNumberSimples titulo="CPF" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={11}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Cpf }
                                                                  obrigatorio={ !this.controller.motoristaBloqueado && this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                                  bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaCpfMotorista > 0) : true}
                                                                  alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.CpfString===0 ) ? this.controller.msgObrigatorio : false }
                                                                  onChange={ (event) => { this.controller.dadosDoServico.AgendServMotorista.Cpf = parseInt(event.target.value); this.controller.dadosDoServico.AgendServMotorista.CpfString = event.target.value; } } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputIdentidade)
                                && <FormOnlyPositiveNumberSimples titulo="Identidade" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={11}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Identidade }
                                                                  bloqueado={ !this.temInicioPrevisto() ? this.controller.motoristaBloqueado && this.controller.bloqueiaIdentidadeMotorista : true}
                                                                  onChange={ (event) => { this.controller.dadosDoServico.AgendServMotorista.Identidade = parseInt(event.target.value.toUpperCase()); this.controller.dadosDoServico.AgendServMotorista.IdentidadeString = event.target.value.toUpperCase() } } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.selectOrgaoExpedidor)
                                && <FormSelectSimples titulo="Órgão expedidor" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                      itens={ this.controller.orgaosExpedidores }
                                                      dado={ this.controller.orgaoExpedidorSelecionado }
                                                      bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaOrgEmissId) : true}
                                                      onChange={ (event) => this.controller.changeOrgao(event) } /> }
                        </Row>
                    </Card>
                </Card>
            </Col>
    };

    desistenciaDeVistoria = () => {
        if (this.controller.parametrosDeCampos.desistenciaDeVistoria && !this.controller.blValido) {
            const mensagem = "Existe divergência de lacre e para continuar é necessário desistir da vistoria. Deseja desistir da vistoria para continuar o agendamento?";
            return <Card className={"secao secao-vistoria"} title={"Desistência de vistoria"} >
                    <Row>
                        <CheckboxArea xs={12} sm={12} md={12} lg={12} xl={12}
                                      titulo={ <Label className="label-primary">ATENÇÃO!</Label> }
                                      mensagem={ <Label className="label-disabled">{ mensagem }</Label> }
                                      checked={ this.controller.dadosDoServico.AgendServ.DesistiuVistoria }
                                      onClick={ () => this.controller.dadosDoServico.AgendServ.DesistiuVistoria = !this.controller.dadosDoServico.AgendServ.DesistiuVistoria } />
                    </Row>
                </Card>
            }
    };

    pesagemSolas = () => {
        let md = 3; let lg = 3; let xl = 3;
        if (this.controller.parametrosDeCampos.pesagemSolas)
            return <Card className={"secao"} title={"Pesagem de solas"} >
                    <Row>
                        { this.campoInputContainer(md, lg, xl, 0) }
                    </Row>
                </Card>
    };

    pesagemContainersImportacao = () => {
        let md = 3; let lg = 3; let xl = 3;
        if (this.controller.parametrosDeCampos.pesagemContainersImportacao)
            return <Card className={"secao"} title={"Pesagem de containers de importação"} >
                    <Row>
                        { this.campoSelectBl(md, lg, xl) }
                        { this.campoInputMostraRazao(md, lg, xl) }
                    </Row>
                    <Row>
                        { this.campoTabelaContainers(7, 7, 7) }
                        { this.campoInsereAnexos(5, 5, 5) }
                    </Row>
                    <Row>
                        { this.campoObservacao(6, 6, 6) }
                    </Row>
                </Card>
    };

    pesagemContainersExportacao = () => {
        let md = 3; let lg = 3; let xl = 3;
        if (this.controller.parametrosDeCampos.pesagemContainersExportacao)
            return <Card className={"secao"} title={"Pesagem de containers de exportação"} >
                    <Row>
                        <FormInputSimples titulo="Booking" xs={12} sm={12} md={4} lg={4} xl={4}
                                          dado={ this.controller.dadosDoServico.AgendServ.NumBooking }
                                          bloqueado={this.temInicioPrevisto()}
                                          obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.inputBooking}
                                          onChange={ (event) => this.controller.dadosDoServico.AgendServ.NumBooking = event.target.value.toUpperCase() }
                                          alerta={ this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.inputBooking && (this.controller.dadosDoServico.AgendServ.NumBooking===null || this.controller.dadosDoServico.AgendServ.NumBooking.length===0) ? this.controller.msgObrigatorio : false }
                                          onBlur={ () => this.controller.onBlurBooking() } />
                    </Row>
                    { this.controller.parametrosDeCampos.inputCliente
                        && <Row>
                            { this.checkboxEhClienteEstrangeiro(md, lg, xl) }
                            { !this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                                && <React.Fragment>
                                    {this.campoInputCliente(md, lg, xl)}
                                    {this.campoInputMostraRazao(md, lg, xl)}
                                </React.Fragment>
                            }
                            { this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                                && this.campoSelectClienteEstrangeiro(md, lg, xl)
                            }
                        </Row>
                    }
                    { this.controller.parametrosDeCampos.inputCobrarDe
                        && <Row>
                            { this.checkboxEhCobrarDeEstrangeiro(md, lg, xl) }
                            { !this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                                && <React.Fragment>
                                    { this.campoInputCobrarDe(md, lg, xl) }
                                    { this.campoInputMostraRazaoCobrarDe(md, lg, xl) }
                                </React.Fragment>
                            }
                            { this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                                && this.campoSelectCobrarDeEstrangeiro(md, lg, xl)
                            }
                        </Row>
                    }
                    <Row>
                        { this.campoTabelaContainers(7, 7, 7) }
                        { this.campoInsereAnexos(5, 5, 5) }
                    </Row>
                    <Row>
                        { this.campoObservacao(6, 6, 6) }
                    </Row>
                </Card>
    };
    // FIM Area de formularios

    footer = () => {
        return <Footer className="footer-opcoes justify-content-between">
            <Row className="area-form footer-content no-gutters mb-0">
                {(this.controller.parametrosDeCampos.dataHora) && !(this.controller.semData.includes(this.controller.grupoSelecionado.value))
                    && <React.Fragment>
                        <Col xs={12}
                                md={ this.controller.horas ? {size: '4', offset: 3 } : {size: '4', offset: 4 }}
                                lg={ this.controller.horas ? {size: '4', offset: 3 } : {size: '4', offset: 6 }}
                                xl={ this.controller.horas ? {offset: 3} : {offset: 6}} className="pl-2">
                            <FormGroup className="footer-select">
                                <Label className="footer-select--label" >Data</Label>
                                <Select className="select" placeholder={ "" }
                                        noOptionsMessage={ () => { "Sem opções" } }
                                        isClearable={true}
                                        isDisabled={!this.temInicioPrevisto() ? !this.controller.datas : true}
                                        value={ this.controller.dataSelecionada }
                                        onChange={ (event) => this.controller.changeData(event) }
                                        menuPlacement = "auto"
                                        options={ this.controller.datas }
                                        />
                            </FormGroup>
                            { (this.controller.salvo && this.controller.tipoSelecionado.RefTipoServ!=="SVCS" && !(this.controller.semData.includes(this.controller.grupoSelecionado.value)) && !this.controller.dataSelecionada)
                                ? <Label className="label-danger ml-5">{ this.controller.msgObrigatorio }</Label> : "" }
                        </Col>
                        { this.controller.buscandoHora && <IconeCarregar className={"carregando-footer"} tamanho="2x" /> }

                        { this.controller.horas
                            && <Col xs={12} md={4} lg={4} xl={3} className="pl-2" >
                                <FormGroup className="footer-select">
                                    <Label className="footer-select--label">Hora</Label>
                                    <Select className="select" placeholder={""}
                                            noOptionsMessage={() => { "Sem opções" }}
                                            isClearable={true}
                                            isSearchable={this.controller.horas.length > 5}
                                            isDisabled={!this.temInicioPrevisto() ? !this.controller.horas : true}
                                            value={this.controller.horaSelecionada}
                                            onChange={(event) => this.controller.changeHora(event)}
                                            menuPlacement="auto"
                                            options={this.controller.horas}
                                            />
                                </FormGroup>
                                { (this.controller.salvo && this.controller.tipoSelecionado.RefTipoServ!=="SVCS" && !this.controller.horaSelecionada)
                                    ? <Label className="label-danger ml-5">{ this.controller.msgObrigatorio }</Label> : "" }
                            </Col>
                        }
                    </React.Fragment>
                }

                {this.controller.tipoSelecionado
                    && <Col xs={"auto"} xl={2} className="ml-auto ml-2">
                        {!this.controller.salvando
                            ? <div><Button className="btn-primary" onClick={() => this.controller.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA" ? this.controller.finalizarAgendamentoMultiplos() : this.controller.finalizarAgendamento()}>FINALIZAR AGENDAMENTO</Button></div>
                            : <IconeCarregar tamanho="2x" />
                        }
                    </Col>}
            </Row>

        </Footer>
    };

    modalDesistencia() {
        if (this.controller.exibirModalDesistenciaVistoria)
        {
            return  <ModalForm
                        className="tamanho-modal-acomproc"
                        labelConfirmar="SIM"
                        labelCancelar="NÃO"
                        onClickSalvar={this.controller.desistirVistoria}
                        onClickCancelar={() => this.controller.fecharModalDesistenciaVistoria()}
                    >
                        <h2>Você realmente deseja desistir da vistoria de lacre?</h2>
                        {!process.env.rig
                            ? <p className="text-desistencia">Presença de carga enviada sem a conferência física da carga.
                            Caso o importador prefira aguardar a conferência física para avaliar a integridade da carga,
                        antes do registro da DI, deverá programar a desova e conferência junto ao {!process.env.rig ? "Atendimento ao Cliente" : "GAC"}.</p>
                            : <p className="text-desistencia">O Importador acima mencionado, através de seu representante abaixo assinado,
                                DESISTE da vistoria dos volumes acima citados, assumindo inteira responsabilidade pelo ônus
                                decorrente desta desistência e DECLARA concordar que após a retirada da carga das dependências do TECON RIO GRANDE S/A,
                                o referido terminal está isento de qualquer responsabilidade sobre o conteúdo da carga, razão pela qual, em nenhuma hipótese
                            poderá ser responsabilizado por qualquer custo e/ou dano direto ou indireto.</p>
                        }
                    </ModalForm>
        }
    }

    modalMensagemDesistencia(){
        if (this.controller.desistenciaMensagem)
        {
            return  <ModalAviso
                        onClickFechar={() => this.controller.desistenciaMensagem = ""}
                    >
                        <h2>
                            {this.controller.desistenciaMensagem}
                        </h2>
                    </ModalAviso>
        }
    }

    handleAvisoDivergencia = () => {
        this.controller.fecharModalDivergencia();
        this.controller.mostrarModalDesistenciaVistoria();
    }

    modalAvisoDivergencia() {
        if (this.controller.exibirModalDivergencia)
        {
            console.log('ta entrando neste lugar?')
            return  <ModalForm
                        className="tamanho-modal-acomproc"
                        labelConfirmar="Desistir da vistoria"
                        labelCancelar="Cancelar"
                        onClickSalvar={this.handleAvisoDivergencia}
                        onClickCancelar={() => this.controller.fecharModalDivergencia()}
                    >
                        <h4>{this.controller.msgModalDivergencia}</h4>
                        
                    </ModalForm>
        }
        else
          return <div />
    }

    temInicioPrevistoMultiplos = (pos) => {
        if (["MANUSEIO DE IMPORTACAO","MANUSEIO DE EXPORTACAO"].includes(this.controller.grupoSelecionado.label))
            return this.controller.listaComponente.items[pos] && this.controller.listaComponente.items[pos].AgendServ.DatFimPrev
        else 
         return false
    };


    ativaFlagComboio = (pos) =>{
        if(this.controller.listaComponente.items[pos].itemAtivo){
            if (this.controller.listaComponente.items[pos].AgendServ.FlgComboio == this.controller.listaComponente.items[pos].AgendServ.FlgComboio === 'S') {
                this.controller.listaComponente.items[pos].AgendServ.FlgComboio = 'N'
            } else
            {
                this.controller.listaComponente.items[pos].AgendServ.FlgComboio = 'S'
            }
            
            if (this.controller.listaComponente.items[pos].AgendServ.FlgComboio==='S') {
                this.controller.changeBlNumeroMultiplos(this.controller.listaComponente.items[pos].blNumero, pos)
            } else {
                this.controller.changeBlNumeroMultiplos("", pos);
            }
        }
    }

    retornaComponent(container, posContainer) {
        let md = 3; let lg = 3; let xl = 3;
        let tamAnexos = (this.controller.parametrosDeCampos.selectNCM && container.ncms) ? 3 : 6;
        return <div>
            <Card className={"secao"} title={"Dados de BL"} >
                <Row>
                <React.Fragment>
                    {/* <FormSelectSimples titulo="Tipo" xs={12} sm={12} md={md} lg={lg} xl={xl}
                            itens={ this.controller.tipos }
                            dado={ container.tipoSelecionado }
                            bloqueado={ !this.temInicioPrevistoMultiplos(posContainer) ? (!this.controller.tipos || container.isEditar) : true}
                            onChange={(event) => this.controller.onChangeTipoMultiplos(event, posContainer)} /> */}
                        
                        {container.atualiza && this.controller.parametrosDeCampos.selectBL &&
                        
                        <FormInputSimples titulo="BL" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                        dado={ container.blNumero }
                                        bloqueado={ !this.temInicioPrevistoMultiplos(posContainer) ? !container.bls : true}
                                        obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.selectBL}
                                        alerta={this.controller.alertaNumeroBlMultiplos(posContainer)}
                                        onChange={(event) => this.controller.setBLNumeroMultiplos(event, posContainer, container) } 
                                        onBlur={(event) => this.controller.changeBlNumeroMultiplos(event, posContainer, container)} 
                                        onEnter={() => this.controller.changeBlNumeroMultiplos(container.blNumero, posContainer, container)}
                            />}
                        
                    </React.Fragment>
                    {this.controller.parametrosDeCampos.inputMostraCliente &&
                       
                       <Col className={"form-input-simples"}
                       xs={12} sm={12} md={md} lg={lg} xl={xl}
                       >
                            <div className="w-100">
                            { <Label className={"label-disabled"}>CNPJ</Label> }
                         <Input className={""} xs={12} md={md} lg={lg}
                                     defaultValue={container.AgendServ.CnpjCobrar}
                                    type={"text"}
                                    disabled={true}
                                     placeholder={""}/>
                         </div>
                     </Col>
                        }
                

                            {this.controller.parametrosDeCampos.inputMostraCliente &&
                            <Col className={"form-input-simples"}
                                xs={12} sm={12} md={md} lg={lg} xl={xl}
                                >
                                    <div className="w-100">
                                    { <Label className={"label-disabled"}>Razão social</Label> }
                                <Input className={""} xs={12} sm={12} md={md} lg={lg}
                                            defaultValue={container.AgendServ.RazaoSocialCobrar}
                                            type={"text"}
                                            disabled={true}
                                            placeholder={""}/> 
                              </div>  </Col>
                        }

                                                
                      

                                { this.controller.parametrosDeCampos.inputDiasFreetime && container.atualiza &&
                                    <FormOnlyPositiveNumberSimples titulo="Dias freetime" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                  dado={ container.AgendServ.DiasFreetime }
                                                  bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                                  iconeInfo={true}
                                                  limiteMaximo={3}
                                                  informacoes={"Favor inserir freetime (demurrage) negociado entre armador e importador"}
                                                  onChange={ (event) => {container.AgendServ.DiasFreetime = event.target.value.toUpperCase()} } />}
                    

                     { (this.controller.parametrosDeCampos.checkboxComboio)
                        && <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                          text={"Sim"}
                                          titulo={"Carregamento de comboio?"}
                                          bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                          ativo={ container.AgendServ.FlgComboio==='S' }
                                          onClick={ () => { 
                                            container.AgendServ.FlgComboio = container.AgendServ.FlgComboio==='S' ? 'N' : 'S';
                                            container.AgendServ.FlgComboio==='S' ? this.controller.changeBlNumeroMultiplos(container.blNumero, posContainer, container) : 
                                            this.controller.changeBlNumeroMultiplos("", posContainer, container);
                                          } } /> } 
                </Row>
            </Card>

            { this.controller.parametrosDeCampos.desistenciaDeVistoria && !container.blValido &&
            
            <Card className={"secao secao-vistoria"} title={"Desistência de vistoria"} >
                    <Row>
                        <CheckboxArea xs={12} sm={12} md={12} lg={12} xl={12}
                                      titulo={ <Label className="label-primary">ATENÇÃO!</Label> }
                                      mensagem={ <Label className="label-disabled">Existe divergência de lacre e para continuar é necessário desistir da vistoria. Deseja desistir da vistoria para continuar o agendamento?</Label> }
                                      checked={ container.AgendServ.DesistiuVistoria }
                                      onClick={ () => container.AgendServ.DesistiuVistoria = !container.AgendServ.DesistiuVistoria } />
                    </Row>
               </Card>}
            

            
            {this.controller.parametrosDeCampos.pesagemSolas &&
                <Card className={"secao"} title={"Pesagem de solas"} >
                    <Row>                        
                        {this.controller.parametrosDeCampos.pesagemSolas &&
                            <Card className={"secao"} title={"Pesagem de solas"} >
                                <Row>
                                    { this.controller.parametrosDeCampos.inputContainer && container.AgendServItens[0] &&
                                        <FormInputSimples titulo="Container" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                 dado={ container.AgendServItens[0].CodCntr }
                                                 bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                                 obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.inputContainer }
                                                 alerta={ this.controller.alertaContainerMultiplos(posContainer) }
                                                 onChange={ (event) => container.AgendServItens[0].CodCntr = event.target.value.toUpperCase() } />}
            
                                </Row>
                            </Card>}

                    </Row>
                </Card>}           
            {this.controller.parametrosDeCampos.dadosGerais &&
            <Card className={"secao"} title={"Dados gerais"} >
                <Row>                        
                        {this.controller.parametrosDeCampos.inputContainer && container.AgendServItens[0] &&
                            <FormInputSimples titulo="Container" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                dado={container.AgendServItens[0].CodCntr}
                                bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.inputContainer}
                                alerta={this.controller.alertaContainerMultiplos(posContainer)}
                                onChange={(event) => container.AgendServItens[0].CodCntr = event.target.value.toUpperCase()} />}


                    { this.controller.parametrosDeCampos.selectContainer
                        && <FormSelectSimples titulo="Container" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                              itens={ container.containersSetPoint }
                                              dado={ tcontainer.containerSetPointSelecionado }
                                              bloqueado={!this.temInicioPrevistoMultiplos(posContainer) ? !container.containersSetPoint : true}
                                              obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.selectContainer}
                                              alerta={ (container.salvo && !container.containerSetPointSelecionado) ? container.msgObrigatorio : false }
                                              onChange={ (event) => this.controller.changeContainerSetPoint(event, 0, posContainer) } /> }
                </Row>
                 { this.controller.parametrosDeCampos.inputCliente
                    && <Row>
                            {this.controller.parametrosDeCampos.checkEhClienteEstrangeiro &&
                             <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                  titulo={"É cliente estrangeiro?"} text={"Sim"}
                                  bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                  ativo={ container.AgendServ.EhClienteEstrangeiro }
                                  onClick={ () => this.controller.changeEhClienteEstrangeiroMultiplos(posContainer) } />}

                        { !container.AgendServ.EhClienteEstrangeiro
                            && <React.Fragment>
                                    {this.controller.parametrosDeCampos.inputCliente &&
                                    <FormInput titulo="Cliente " xs={12} sm={12} md={md} lg={lg} xl={xl}
                                        dado={container.AgendServ.CnpjDespa}
                                        sanitizar={sanitizarCnpj}
                                        limiteMaximo={14}
                                        onChange={(event) => container.AgendServ.CnpjDespa = event.target.value ? event.target.value : null}
                                        obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.inputCliente}
                                        bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                        alerta={this.controller.alertaClienteMultiplos(posContainer)}
                                        onBlur={() => this.controller.buscarParceiroPorCnpjMultiplos(posContainer)}
                                    />}
                                    
                                   { this.controller.parametrosDeCampos.inputMostraRazSocial &&
                                    <FormInputSimples titulo="Razão social" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                        dado={container.AgendServ.RazaoSocialDespa}
                                        bloqueado={true}
                                        onChange={() => { }} /> }                                    
                            </React.Fragment>
                        }
                        { container.AgendServ.EhClienteEstrangeiro
                                &&   this.controller.parametrosDeCampos.selectClienteEstrangeiro && 
                                        <FormSelectSimples titulo="Cliente" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                                          itens={container.clientesEstrangeiros}
                                                          dado={container.clienteEstrangeiroSelecionado}
                                                          bloqueado={!this.temInicioPrevistoMultiplos(posContainer) ? !container.clientesEstrangeiros: true}
                                                          alerta={ this.controller.alertaClienteMultiplos(posContainer) }
                                                          onChange={(event) => this.controller.changeClienteEstrangeiroMultiplos(event, posContainer)} />
                        }
                    </Row>
                }
                { this.controller.parametrosDeCampos.inputCobrarDe
                    && <Row>

                        { !container.AgendServ.EhCobrarDeEstrangeiro && this.controller.parametrosDeCampos.checkEhCobrarDeEstrangeiro &&
                            <React.Fragment>
                                    
                            <CheckboxField xs={12} sm={12} md={md} lg={lg} xl={xl} widthAuto={true}
                                  titulo={"É cobrar de estrangeiro?"} text={"Sim"}
                                  bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                  ativo={ container.AgendServ.EhCobrarDeEstrangeiro }
                                        onClick={() => this.controller.changeEhCobrarDeEstrangeiro()} />
                                    
                                    {
                                    this.controller.parametrosDeCampos.inputMostraRazSocialCobrarDe &&
                                     <FormInputSimples titulo="Razão social" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                        dado={container.AgendServ.RazaoSocialCobrar}
                                        bloqueado={true}
                                        onChange={() => { }} />
                                    }
                            </React.Fragment>
                        }
                            
                            {container.AgendServ.EhCobrarDeEstrangeiro
                                &&
                                this.controller.parametrosDeCampos.selectClienteEstrangeiro &&
                                 <FormSelectSimples titulo="Cobrar de" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                                          itens={ container.clientesEstrangeiros}
                                                          dado={  container.cobrarDeEstrangeiroSelecionado }
                                                          bloqueado={!this.temInicioPrevistoMultiplos(posContainer) ? ! container.clientesEstrangeiros : true}
                                                          alerta={ this.controller.alertaCobrarDeMultiplos(posContainer) }
                                                          onChange={(event) => this.controller.changeCobrarDeEstrangeiroMultiplos(event, posContainer)} />
                        }
                    </Row>
                }
                    
              <Row>                        
                        { this.controller.parametrosDeCampos.tabelaSelecionarContainers &&
                        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                            <Label>Seleção dos containers</Label>
                            <AreaSelecaoContainersMultiplos controller={this.controller} posContainer={posContainer} bloqueado={this.temInicioPrevistoMultiplos(posContainer)} />
                            { (container.salvo && this.controller.parametrosDeCampos.camposObrigatorios.tabelaSelecionarContainers && container.AgendServItens.length===0)
                                && <Label className="label-danger">{container.msgObrigatorio }</Label> }
                        </Col>}

                        
                       {this.controller.parametrosDeCampos.selectNCM && container.ncms &&
                        <Col xs={12} sm={12} md={6} lg={3} xl={3}>
                        <Label>Seleção de NCM</Label>
                        <AreaSelecaoNCMsMultiplos controller={this.controller} posContainer={posContainer} bloqueado={this.temInicioPrevistoMultiplos(posContainer)} />
                        { (container.salvo && this.controller.parametrosDeCampos.camposObrigatorios.selectNCM && container.AgendServItens.length===0)
                            && <Label className="label-danger">{ container.msgObrigatorio }</Label> } 
                        {this.controller.parametrosDeCampos.msgNCM &&
                            <div className="d-flex align-items-center">
                                <div><IconeInformacao className="pr-1" /></div>
                                <Label className="mt-1 informacoes">{ this.controller.parametrosDeCampos.msgNCM }</Label>
                            </div> }                       
                    </Col>}


                        {  this.controller.parametrosDeCampos.campoInsereAnexos &&
                         <Col xl={tamAnexos} lg={tamAnexos} md={6} sm={12} xs={12}>
                            <Label>Anexos</Label>
                            <AreaInserirAnexos anexos={  container.listaAnexos } 
                                            guardaNovo={(event) => this.controller.insereAnexoMultiplos(event, posContainer) } 
                                            removerAnexo={ (event) => this.controller.removerAnexoMultiplos(event, posContainer) } 
                                            visualizarAnexo={ this.controller.visualizarAnexoMultiplos } 
                                            edicao={ container.isEditar} 
                                            descricao={"descricao"} 
                            />
                            {  this.controller.parametrosDeCampos.msgAnexos
                                && <div className="d-flex align-items-center">
                                    <div><IconeInformacao className="pr-1" /></div>
                                    <Label className="informacoes">{  this.controller.parametrosDeCampos.msgAnexos }</Label>
                                </div> }
                        </Col>}
                        

                        
                </Row>
                <Row>
                        
                        { this.controller.parametrosDeCampos.inputObservacao &&
                        <FormInputSimples titulo="Observações" xs={12} sm={12} md={6} lg={6} xl={6}
                                    dado={ container.AgendServ.DscObs }
                                    bloqueado={this.temInicioPrevistoMultiplos(posContainer)}
                                    type="textarea" limiteMaximo={2000}
                                    iconeInfo={container.observacaoGrupo.length>0}
                                    extraInfo={container.observacaoGrupo}
                                    onChange={ (event) => container.AgendServ.DscObs = event.target.value.toUpperCase() }/>}
                </Row> 
            </Card>}



        </div>
    }

    handleOnBlurContainer = ( posContainer, container ) => {
        console.log(posContainer)
    }

    handleRemoverContainer = (posContainer) => {
        // let ctrnAtivo = (index === 0) ? 0 : index - 1;
        this.controller.listaComponente.items.splice(posContainer,1);
    };


    handleSelecionaContainer = (pos) => {
        this.controller.listaComponente.items.map((item, index) => {
            if (index === pos) {
                item.itemAtivo = true;
            } else {
                item.itemAtivo = false;
            }
        })
    }

    dadosDaTransportadoraMultiplos = () => {
        let md = 6; let lg = 6; let xl = 6;
        if (this.controller.parametrosDeCampos.dadosDaTransportadora)
            return <Col xs={12} sm={12} md={6} lg={6} xl={6} >
                    <Card className={"secao"} title={"Dados do veículo"} >
                        <Card className={"card-branco"} >
                            <Row className={"secao"}>
                            { (this.controller.parametrosDeCampos.selectTransportadora)
                                && <FormSelectSimples titulo="Transportadora" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    itens={ this.controller.transportadoras }
                                                    dado={ this.controller.transportadoraSelecionada }
                                                    bloqueado={ !this.temInicioPrevisto() ? !this.controller.transportadoras : true}                                                    
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && !this.controller.transportadoraSelecionada) ? this.controller.msgObrigatorio : false }
                                                    onChange={ (event) => this.controller.changeTransportadora(event) } /> }
                            { (this.controller.parametrosDeCampos.selectTipoDeVeiculo)
                                && <FormSelectSimples titulo="Tipo de veículo" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    itens={ this.controller.tiposVeiculo }
                                                    dado={ this.controller.tipoVeiculoSelecionado }
                                                    bloqueado={ !this.temInicioPrevisto() ? !this.controller.tiposVeiculo : true }
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && !this.controller.tipoVeiculoSelecionado) ? this.controller.msgObrigatorio : false }
                                                    onChange={ (event) => this.controller.changeTipoVeiculo(event) } /> }
                            { (this.controller.parametrosDeCampos.inputPlaca)
                                && <FormInputSimples titulo="Placa" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCavalo }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCavalo && this.controller.dadosDoServico.AgendServ.PlacaCavalo.length===0 ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacas }
                                                    obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora }
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCavalo = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacas = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCavalo) } } /> }
                            { (this.controller.parametrosDeCampos.inputCarreta1)
                                && <FormInputSimples titulo="Carreta 1" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCarret1 }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCarret1 && this.controller.dadosDoServico.AgendServ.PlacaCarret1.length===0 ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacaCarret1 }
                                                    obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora}
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCarret1 = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacaCarret1 = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCarret1) } } /> }
                            { (this.controller.parametrosDeCampos.inputCarreta2)
                                && <FormInputSimples titulo="Carreta 2" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                    dado={ this.controller.dadosDoServico.AgendServ.PlacaCarret2 }
                                                    bloqueado={ this.temInicioPrevisto()}
                                                    alerta={ (this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora && this.controller.dadosDoServico.AgendServ.PlacaCarret2 && this.controller.dadosDoServico.AgendServ.PlacaCarret2.length===0 && this.controller.tipoVeiculoSelecionado.value==='B' ) ? this.controller.msgObrigatorio : this.controller.estadoAlertaPlacaCarret2 }
                                                    obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora
                                                                    && this.controller.tipoVeiculoSelecionado && this.controller.tipoVeiculoSelecionado.value==='B'}
                                                    onChange={ (event) => { this.controller.dadosDoServico.AgendServ.PlacaCarret2 = event.target.value.toUpperCase(); this.controller.estadoAlertaPlacaCarret2 = isInvalidoPlacas(this.controller.dadosDoServico.AgendServ.PlacaCarret2) } } /> }
                            </Row>
                        </Card>
                    </Card>
                </Col>
    };



    dadosDoMotoristaMultiplos = () => {
        let md = 6; let lg = 6; let xl = 6;
        if (this.controller.parametrosDeCampos.dadosDoMotorista)
            return <Col xs={12} sm={12} md={6} lg={6} xl={6} >
                    <Card className={"secao"} title={"Dados do motorista"} >
                        <Card className={"card-branco"} >
                            <Row className={"secao"} >
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputCNH)
                                && <FormOnlyPositiveNumberSimples titulo="CNH" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={15}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Cnh }
                                                                  bloqueado={ this.temInicioPrevisto()}
                                                                  obrigatorio={ this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                                  alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.Cnh===0 ) ? this.controller.msgObrigatorio : false }
                                                                  onChange={ (event) => {this.controller.dadosDoServico.AgendServMotorista.Cnh = parseInt(event.target.value); 
                                                                                         this.controller.dadosDoServico.AgendServ.Cnh = parseInt(event.target.value)}}
                                                                  onBlur={ () => this.controller.onBlurMotoristaCNH() } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.selectCategoria)
                                && <FormSelectSimples titulo="Categoria" xs={12} sm={12} md={md} lg={lg} xl={xl} obrigatorio={true}
                                                      itens={ this.controller.categorias }
                                                      dado={ this.controller.categoriaSelecionada }
                                                      bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaCategCnh)  : true}
                                                      alerta={ (this.controller.salvo && !this.controller.categoriaSelecionada) ? this.controller.msgObrigatorio : false }
                                                      onChange={ (event) => this.controller.changeCategoria(event) } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputNome)
                                && <FormInputSimples titulo="Nome" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                     dado={ this.controller.dadosDoServico.AgendServMotorista.Nome }
                                                     obrigatorio={ !this.controller.motoristaBloqueado && this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                     bloqueado={ !this.temInicioPrevisto() ? this.controller.motoristaBloqueado && this.controller.bloqueiaNomeMotorista : true}
                                                     alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.Nome && this.controller.dadosDoServico.AgendServMotorista.Nome.length===0 ) ? this.controller.msgObrigatorio : false }
                                                     onChange={ (event) => this.controller.dadosDoServico.AgendServMotorista.Nome = event.target.value.toUpperCase() } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputCPF)
                                && <FormOnlyPositiveNumberSimples titulo="CPF" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={11}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Cpf }
                                                                  obrigatorio={ !this.controller.motoristaBloqueado && this.controller.parametrosDeCampos.camposObrigatorios.dadosDoMotorista }
                                                                  bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaCpfMotorista > 0) : true}
                                                                  alerta={ (this.controller.salvo && this.controller.dadosDoServico.AgendServMotorista.CpfString===0 ) ? this.controller.msgObrigatorio : false }
                                                                  onChange={ (event) => { this.controller.dadosDoServico.AgendServMotorista.Cpf = parseInt(event.target.value); this.controller.dadosDoServico.AgendServMotorista.CpfString = event.target.value; } } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.inputIdentidade)
                                && <FormOnlyPositiveNumberSimples titulo="Identidade" xs={12} sm={12} md={md} lg={lg} xl={xl} limiteMaximo={11}
                                                                  dado={ this.controller.dadosDoServico.AgendServMotorista.Identidade }
                                                                  bloqueado={ !this.temInicioPrevisto() ? this.controller.motoristaBloqueado && this.controller.bloqueiaIdentidadeMotorista : true}
                                                                  onChange={ (event) => { this.controller.dadosDoServico.AgendServMotorista.Identidade = parseInt(event.target.value.toUpperCase()); this.controller.dadosDoServico.AgendServMotorista.IdentidadeString = event.target.value.toUpperCase() } } /> }
                            { (this.controller.atualiza && this.controller.parametrosDeCampos.selectOrgaoExpedidor)
                                && <FormSelectSimples titulo="Órgão expedidor" xs={12} sm={12} md={md} lg={lg} xl={xl}
                                                      itens={ this.controller.orgaosExpedidores }
                                                      dado={ this.controller.orgaoExpedidorSelecionado }
                                                      bloqueado={ !this.temInicioPrevisto() ? (this.controller.motoristaBloqueado && this.controller.bloqueiaOrgEmissId) : true}
                                                      onChange={ (event) => this.controller.changeOrgao(event) } /> }
                        </Row>
                    </Card>
                </Card>
            </Col>
    };



    pesagemContainersImportacaoMultiplos = () => {
        let md = 3; let lg = 3; let xl = 3;
        if (this.controller.parametrosDeCampos.pesagemContainersImportacao)
            return <Card className={"secao"} title={"Pesagem de containers de importação"} >
                    <Row>
                        { this.campoSelectBl(md, lg, xl) }
                        { this.campoInputMostraRazao(md, lg, xl) }
                    </Row>
                    <Row>
                        { this.campoTabelaContainers(7, 7, 7) }
                        { this.campoInsereAnexos(5, 5, 5) }
                    </Row>
                    <Row>
                        { this.campoObservacao(6, 6, 6) }
                    </Row>
                </Card>
    };

    pesagemContainersExportacaoMultiplos = () => {
        let md = 3; let lg = 3; let xl = 3;
        if (this.controller.parametrosDeCampos.pesagemContainersExportacao)
            return <Card className={"secao"} title={"Pesagem de containers de exportação"} >
                    <Row>
                        <FormInputSimples titulo="Booking" xs={12} sm={12} md={4} lg={4} xl={4}
                                          dado={ this.controller.dadosDoServico.AgendServ.NumBooking }
                                          bloqueado={this.temInicioPrevisto()}
                                          obrigatorio={this.controller.parametrosDeCampos.camposObrigatorios.inputBooking}
                                          onChange={ (event) => this.controller.dadosDoServico.AgendServ.NumBooking = event.target.value.toUpperCase() }
                                          alerta={ this.controller.salvo && this.controller.parametrosDeCampos.camposObrigatorios.inputBooking && (this.controller.dadosDoServico.AgendServ.NumBooking===null || this.controller.dadosDoServico.AgendServ.NumBooking.length===0) ? this.controller.msgObrigatorio : false }
                                          onBlur={ () => this.controller.onBlurBooking() } />
                    </Row>
                    { this.controller.parametrosDeCampos.inputCliente
                        && <Row>
                            { this.checkboxEhClienteEstrangeiro(md, lg, xl) }
                            { !this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                                && <React.Fragment>
                                    {this.campoInputCliente(md, lg, xl)}
                                    {this.campoInputMostraRazao(md, lg, xl)}
                                </React.Fragment>
                            }
                            { this.controller.dadosDoServico.AgendServ.EhClienteEstrangeiro
                                && this.campoSelectClienteEstrangeiro(md, lg, xl)
                            }
                        </Row>
                    }
                    { this.controller.parametrosDeCampos.inputCobrarDe
                        && <Row>
                            { this.checkboxEhCobrarDeEstrangeiro(md, lg, xl) }
                            { !this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                                && <React.Fragment>
                                    { this.campoInputCobrarDe(md, lg, xl) }
                                    { this.campoInputMostraRazaoCobrarDe(md, lg, xl) }
                                </React.Fragment>
                            }
                            { this.controller.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro
                                && this.campoSelectCobrarDeEstrangeiro(md, lg, xl)
                            }
                        </Row>
                    }
                    <Row>
                        { this.campoTabelaContainers(7, 7, 7) }
                        { this.campoInsereAnexos(5, 5, 5) }
                    </Row>
                    <Row>
                        { this.campoObservacao(6, 6, 6) }
                    </Row>
                </Card>
    };





    agendamentoMultiploConsolidado = () => {
        return (
        this.controller.grupoSelecionado && this.controller.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA" && 
                       <Card className="form-secoes" >                           
                              {/* {  this.controller.tipoSelecionado && !this.controller.isEditar && <div className="divAllignment">
                                   <Button className="novoComponentADD" onClick={() => this.controller.addComponent()}>+</Button> 
                                </div>} */}
                                {this.controller.tipoSelecionado && <div className="divAllignment">
                                   <Button className="novoComponentADD" onClick={() => this.controller.addComponent()}>+</Button> 
                                </div>}
                                <Row>
                            {this.controller.listaComponente.items &&
                                this.controller.listaComponente.items.map((container, posContainer) => (
                                
                                 <div key={posContainer} className="alinharBotao"
                                 >
                                     <div key={posContainer} className={`card-branco predHeight clicavel ${container.itemAtivo && "card-selecionado-secoes"}`}
                                     onClick={ () => this.handleSelecionaContainer(posContainer) } >
                                         <Row>
                                         <Col xs={6} sm={6} md={8}>
                                                    { container.nome}
                                         </Col>
                                         <Col xs={6} sm={6} md={4}>
                                                <div className="float-right">
                                                {!this.controller.isEditar &&<IconeDelete tamanho="lg"
                                                  onClick={() => this.handleRemoverContainer(posContainer)}
                                                 />}
                                                </div>
                                          </Col>
                                      </Row>
                                    </div>
                                     {/* <Button className="alinharBotao" objeto={this.controller.listaComponente[posContainer]} onClick={() => this.handleOnBlurContainer(posContainer)}>BL{posContainer}</Button> */}
                                     </div> 

                                     
                           
                             ))
                        }   
                           
                           </Row>
                                {this.controller.listaComponente.items &&
                                    this.controller.listaComponente.items.map((container, posContainer) => (
                                            
                                <div id={`bl${posContainer}`}
                                            className={!container.itemAtivo ? "escondido" : "" }
                                        >
                                            {this.retornaComponent(container, posContainer)}
                                    </div>
                                    ))
                                }

                            <Row>
                                {this.dadosDaTransportadoraMultiplos()}
                                {this.dadosDoMotoristaMultiplos()}
                            </Row>
                            {this.pesagemContainersImportacaoMultiplos()}
                            {this.pesagemContainersExportacaoMultiplos() }
        </Card>)
        
    }



    render() {
        return (
            <div className="form-wrapper">
                <Container className="agendamento-servicos-cadastrar" fluid>
                    {this.aviso()}
                    {this.avisoEdicaoIniciadaMultiplos()}
                    { this.modalFimAgendamento() }
                    { this.modalAvisoDivergencia()}
                    { this.modalDesistencia()}
                    { this.modalMensagemDesistencia()}
                    { this.opcoesGerais() }
                    {
                       this.agendamentoMultiploConsolidado()
                    }
                    { this.controller.tipoFormAtivo && this.controller.grupoSelecionado.label !== "CARREGAMENTO DE CARGA SOLTA" && 
                       <Card className="form-secoes" >
                            {this.dadosDoBl()}
                            {this.desistenciaDeVistoria()}
                            {this.pesagemSolas()}
                            {this.dadosGerais()}
                            <Row>
                                {this.dadosDaTransportadora()}
                                {this.dadosDoMotorista()}
                            </Row>
                            {this.pesagemContainersImportacao()}
                            {this.pesagemContainersExportacao()}
                        </Card>
                    }

                    {this.footer()}
                </Container>
            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/cadastrar/telas/AgServicosCadastrar.js